import type { AppFeatureDefinition } from "@nasam/kernel";
import { createAuditRoutes } from "./presentation/routes";
import { AUDIT_LOG_VIEW } from "./auditPermissions";

export * from "./auditPermissions";

export const auditFeature: AppFeatureDefinition = {
  id: "audit",
  version: "0.1.0",
  titleKey: "audit:moduleTitle",
  icon: "FileText",
  basePath: "/audit-logs",
  requiredPermissions: [AUDIT_LOG_VIEW],
  // Every CORE feature shares one "core" rail node (see mergeFeatureNavNodes);
  // this feature contributes the "Audit log" leaf under it.
  navigation: [
    {
      id: "core",
      titleKey: "common:businessModules.core",
      icon: "Layers",
      placement: "rail",
      order: 10,
      children: [
        {
          id: "audit-logs",
          titleKey: "audit:moduleTitle",
          icon: "FileText",
          placement: "drawer",
          order: 110,
          path: "/audit-logs",
          requiredPermissions: [AUDIT_LOG_VIEW],
        },
      ],
    },
  ],
  routes: (context) => createAuditRoutes({ context }),
  permissionCatalog: [
    {
      segment: "core",
      labelKey: "audit:permissions.core",
      children: [
        {
          segment: "audit_management",
          labelKey: "audit:permissions.auditManagement",
          children: [
            {
              segment: "audit_log_list",
              labelKey: "audit:permissions.auditLog",
              actions: [{ id: "view", labelKey: "audit:actions.view" }],
            },
          ],
        },
      ],
    },
  ],
};
